// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"32":"7b1f59507e9ff133","728":"4a81a2f15e250a66","857":"60734eb296872207"}[chunkId] + ".js";
};